import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { AblyTokenType } from 'hb-react/shared/hooks/useSubscribeToAblyChannel/types';

type UseAblyAuthUrl = (tokenType: AblyTokenType) => string | null;

// Ably is not available in PO right now
export const useAblyAuthUrl: UseAblyAuthUrl = (tokenType) => {
  const { currentAdmin, currentUser, currentNetworkId } =
    useDefaultAppContexts();

  if (
    typeof Routes.backoffice_network_ably_token_path === 'function' &&
    (!currentAdmin || !currentNetworkId)
  ) {
    const message = `Trying to use Ably in the backoffice but missing currentAdmin and/or currentNetworkId: { currentAdmin: ${currentAdmin}, currentNetworkId: ${currentNetworkId} }`;

    // `Routes` is faked during tests and typeof Routes.backoffice_network_ably_token_path === 'function' will always be true
    // so we ignore this check during tests
    if (process.env.NODE_ENV !== 'test') {
      throw new Error(message);
    }
  }

  const inBO: boolean = !!(
    currentAdmin &&
    currentNetworkId &&
    typeof Routes.backoffice_network_ably_token_path === 'function'
  );
  const inFO: boolean = !!currentUser;

  if (inBO && currentNetworkId) {
    return Routes.backoffice_network_ably_token_path(currentNetworkId, {
      type: tokenType,
      format: 'json',
    });
  }

  if (inFO) {
    return Routes.ably_token_path({ type: tokenType, format: 'json' });
  }

  // ably is not available in PO for the moment
  return null;
};
